<template>
	<div class='result-table-3'>
		<table class='table-common'>
			<thead>
				<tr>
					<th rowspan='3'>Ярус</th>
					<th colspan='2'>Состав (фактический)</th>
					<th rowspan='3'>{{ lpo.inspection_type_id === '2' ? 'Сумма площадей сечения' : 'Число деревьев на пробе' }}</th>
					<th colspan='14'>{{ lpo.inspection_type_id === '2' ? 'Распределение суммы площадей сечения по категориям состояния, %' : 'Распределение деревьев по категориям состояния, % от запаса' }}</th>
					<th rowspan='3'>СКС</th>
				</tr>
				<tr>

					<th rowspan='2'>Доля породы</th>
					<th rowspan='2'>Порода</th>
					<th colspan='2'>Без признаков ослабления</th>
					<th colspan='2'>Ослабленные</th>
					<th colspan='2'>Сильно ослабленные</th>
					<th colspan='2'>Усыхающие</th>
					<th rowspan='2'>Свежий сухостой</th>
					<th rowspan='2'>Свежий ветровал</th>
					<th rowspan='2'>Свежий бурелом</th>
					<th rowspan='2'>Старый сухостой</th>
					<th rowspan='2'>Старый ветровал</th>
					<th rowspan='2'>Старый бурелом</th>
					<!-- <th>Аварийные деревья</th> -->
				</tr>

				<tr>
					<th>Н</th>
					<th>Р</th>
					<th>Н</th>
					<th>Р</th>
					<th>Н</th>
					<th>Р</th>
					<th>Н</th>
					<th>Р</th>
				</tr>
			</thead>
			<tbody>
				<template v-if='dataIsLoading'>
					<div class='table-common__loading-container'>
						<div>
							<p-spinner class='table-common__loading-spinner'/>
						</div>
						<div class='table-common__loading-text'>Загрузка данных...</div>
					</div>
				</template>

				<template v-if='dataIsLoading && !tableData.length'>
					<tr>
						<td colspan='20' class='table-common__loading-empty-row'></td>
					</tr>
				</template>

				<template v-else>
					<tr v-for='(row, row_i) in tableData' :class='{ "total-row": (row_i === tableData.length - 1) }'>
						<td
							v-if='isLayer(row)'
							:rowspan='speciesLayerCount(row)'
							:colspan='(row_i === tableData.length - 1) ? 3 : 0'
						>
							{{ (row_i === tableData.length - 1) ? 'Итого' : row.layer == 11 ? 'единичные деревья': row.layer  }}
						</td>
						<td v-if='row_i !== tableData.length - 1'>{{ row.coeff }}</td>
						<td v-if='row_i !== tableData.length - 1'>{{ row.species }}</td>
						<td>{{ row.tree_count }}</td>

						<td>{{ row.sc_1 }}</td>
						<td>{{ row.sc_1_r }}</td>
						<td>{{ row.sc_2 }}</td>
						<td>{{ row.sc_2_r }}</td>
						<td>{{ row.sc_3 }}</td>
						<td>{{ row.sc_3_r }}</td>
						<td>{{ row.sc_4 }}</td>
						<td>{{ row.sc_4_r }}</td>
						<td>{{ row.sc_sv_s }}</td>
						<td>{{ row.sc_sv_v }}</td>
						<td>{{ row.sc_sv_b }}</td>
						<td>{{ row.sc_st_s }}</td>
						<td>{{ row.sc_st_v }}</td>
						<td>{{ row.sc_st_b }}</td>
						<!-- <td>{{ row.sc_a }}</td> -->

						<td>{{ row.sks }}</td> <!-- ДОБАВИТЬ ПОЛЕ В ФУНКЦИЮ БД -->
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
	const GET_TABLE_DATA = process.env.VUE_APP_ROOT_API + 'get_site_data/result_tables/table3.php';

	export default {
		name: 'ResultTable3',
		data: () => ({
			tableData: [],
			dataIsLoading: false,
		}),
		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			layerList() {
				const result = [];
				for (let row of this.tableData) {
					if (!result.find(item => item.layer === row.layer)) {
						result.push(row);
					}
				}
				return result;
			}

		},

		methods: {
			isLayer(item) {
				return this.layerList.includes(item);
			},
			speciesLayerCount(item) {
				return this.tableData.filter(row => row.layer === item.layer).length;
			},

			getTableData() {
				this.dataIsLoading = true;

				const form = new FormData();
				form.append('lpo_id', this.lpo.lpo_id);

				fetch(GET_TABLE_DATA, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.tableData = res;
				})
				.catch(err => { throw err; })
				.finally(() => { this.dataIsLoading = false; });
			}
		},
		created() {
			this.getTableData();
		}
	};
</script>

<style lang='scss' scoped src='@/style/tables.scss'></style>

<style scoped>
	.total-row {
		font-weight: bold;
	}
</style>